<div class="changes-card">
  <div class="submission-card-description">{{ label }}</div>
  <ng-content></ng-content>
  <div class="changes-grid">
    <div
      *ngFor="let item of detailsChanges"
      class="d-flex flex-column gap-2 data-field"
      [ngClass]="{
        'new-change': item.hasChanges && changeType === SubmissionDetailsFieldChangeTypeEnum.New,
        'previous-change': item.hasChanges && changeType === SubmissionDetailsFieldChangeTypeEnum.Previous
      }">
      <div class="data-label">{{ item.key }}</div>
      <div
        class="data-value"
        [class.strikethrough]="item.hasChanges && changeType === SubmissionDetailsFieldChangeTypeEnum.Previous">
        {{ item.value }}
      </div>
    </div>
  </div>
</div>
